import { compose, createSelector } from '@reduxjs/toolkit';

import { JsonQuery } from 'shared/types/JsonQuery';
import {
  insertBboxToJsonQuery,
  insertPageToJsonQuery,
  insertSortToJsonQuery,
} from 'shared/utils/insertFieldToJsonQuery';

import { useReduxSelector } from '../../../external/hooks';
import { ReduxState } from '../../../types';
import {
  activePinPageSelector,
  activePinSortSelector,
  mapSelectedBoundsSelector,
} from '../../mapControls/selectors/dumb';

import { filtersSelector, listingSortSelector, pageSelector } from './dumb';

export const completeJsonQuerySelector = createSelector(
  [filtersSelector, listingSortSelector, pageSelector, mapSelectedBoundsSelector],
  (filters, sort, page, selectedBounds) => {
    const jsonQuery: JsonQuery = { ...filters };

    compose(insertPageToJsonQuery(page), insertSortToJsonQuery(sort), insertBboxToJsonQuery(selectedBounds))(jsonQuery);

    return jsonQuery;
  },
);

export function useCompleteJsonQuerySelector(): JsonQuery {
  return useReduxSelector(completeJsonQuerySelector);
}

export const completeJsonQueryByPinSelector = createSelector(
  [filtersSelector, activePinSortSelector, activePinPageSelector],
  (filters, sort, page) => {
    const jsonQuery: JsonQuery = { ...filters };

    compose(insertPageToJsonQuery(page), insertSortToJsonQuery(sort))(jsonQuery);

    return jsonQuery;
  },
);

export function useCompleteJsonQueryByPinSelector(): JsonQuery {
  return useReduxSelector(completeJsonQueryByPinSelector);
}

export const completeSimilarOffersJsonQuerySelector = createSelector(
  [filtersSelector, (_state: ReduxState, page: number | undefined): number | undefined => page],
  (filters, page) => {
    const jsonQuery: JsonQuery = { ...filters };

    compose(insertPageToJsonQuery(page))(jsonQuery);

    return jsonQuery;
  },
);

export const completeClustersJsonQuerySelector = createSelector(
  [filtersSelector, listingSortSelector, pageSelector],
  (filters, sort, page) => {
    const jsonQuery: JsonQuery = { ...filters };

    compose(insertPageToJsonQuery(page), insertSortToJsonQuery(sort))(jsonQuery);

    return jsonQuery;
  },
);
